import APIURL from "../axios";
import { useQuery } from "react-query";

const RestaurantBooking = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/restaurants`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowRestaurantBooking = (uuid, lang) => {
  return useQuery(`restaurant_booking-${lang}`, () =>
    RestaurantBooking(uuid, lang),
  );
};
